const config = {
  baseURL: "https://api.cciahn.org/v1",
  // timeout: 1000,
};

export default config;
